/* Safari (risparmio energetico o "non riprodurre automaticamente") blocca l'avvio da solo:
   niente tasto play di sistema, il video resta sul fotogramma e parte al primo tocco/clic/tasto. */
(function(){
  if (window.nmPlay) return;
  var fermi = [];
  var st = document.createElement('style');
  st.textContent = 'video::-webkit-media-controls-start-playback-button,video::-webkit-media-controls-overlay-play-button{display:none!important;-webkit-appearance:none!important;opacity:0!important}video::-webkit-media-controls-panel{display:none!important}';
  (document.head || document.documentElement).appendChild(st);
  function prova(v){
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function(){ if (fermi.indexOf(v) < 0) fermi.push(v); });
  }
  function riprova(){ var l = fermi; fermi = []; l.forEach(function(v){ if (v.isConnected) prova(v); }); }
  ['pointerup','touchend','mousedown','keydown'].forEach(function(e){ document.addEventListener(e, riprova, { capture: true, passive: true }); });
  window.nmPlay = prova;
})();
/* Carrello del Nemico: sticker a 5 euro con un altro pezzo e bannerino del Live.
   Nell'anteprima laterale ci sono tutti e due; nella pagina carrello solo lo sticker, perche' li'
   il Live e' il banner grande (sezione nemico-banner-biglietto in templates/cart.json).
   Nell'anteprima, in fondo, due bolle: Vai al pagamento e Visualizza carrello.
   I dati arrivano da window.NM_CART (snippets/nemico-filters.liquid), il biglietto dal prodotto.
   Gli sconti li applica la cassa: qui si mostrano soltanto. */
(function(){
  var C = window.NM_CART || {};
  var EUR = function(c){ return (c/100).toFixed(2).replace('.',',') + ' €'; };
  var STICKER_ABB = 500;
  var VIDEO = 'https://cdn.shopify.com/videos/c/vp/e39c17a926794fe491ef072b20960c53/e39c17a926794fe491ef072b20960c53.SD-480p-1.5Mbps-97376281.mp4';
  if (C.stickerUno && !C.stickerUno.prezzo) C.stickerUno.prezzo = 800;

  /* il biglietto si legge dal prodotto stesso: se non e' in vendita il bannerino non compare */
  var pronto = fetch('/products/biglietto-il-nemico-roma-26-11.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){
      if (!p || !p.available) return;
      var v = (p.variants||[]).filter(function(x){ return x.available; })[0] || p.variants[0];
      C.biglietto = { handle: p.handle, vid: v.id, prezzo: v.price, link: '/products/' + p.handle, luogo: 'Hacienda', video: VIDEO };
    })
    .catch(function(){});

  function conta(cart){
    var s = {sticker:0, altri:0, biglietto:false};
    (cart.items||[]).forEach(function(l){
      var h = l.handle || '';
      if (C.biglietto && h === C.biglietto.handle) s.biglietto = true;
      if ((C.sticker||[]).indexOf(h) >= 0) s.sticker += l.quantity;
      else s.altri += l.quantity;
    });
    return s;
  }

  function sticker(s){
    var S = C.stickerUno; if (!S || s.altri === 0) return '';
    var img = S.img ? '<img src="' + S.img + '" alt="" width="36" height="36" loading="lazy">' : '';
    if (s.sticker === 0)
      return '<div class="nm-st">' + img + '<p>' + S.titolo + ' a <strong>' + EUR(STICKER_ABB) + '</strong>' + (S.prezzo ? ' <s>' + EUR(S.prezzo) + '</s>' : '') + ' con il resto</p>' +
        '<button type="button" class="nm-lnk" data-nm-add="' + S.vid + '">Aggiungi</button></div>';
    return '<div class="nm-st">' + img + '<p>Sticker pack a <strong>' + EUR(STICKER_ABB) + '</strong>: lo sconta la cassa.</p></div>';
  }

  function live(s){
    var B = C.biglietto; if (!B || s.biglietto) return '';
    return '<div class="nm-tk">' +
      '<a class="nm-tk__v" href="' + B.link + '" tabindex="-1" aria-hidden="true">' +
        (B.video ? '<video src="' + B.video + '" muted loop playsinline autoplay preload="metadata"></video>' : '') + '</a>' +
      '<div class="nm-tk__x"><a class="nm-tk__t" href="' + B.link + '"><span>Live Roma 26.11</span></a>' +
      '<div class="nm-tk__g"><span class="nm-tk__d">' + B.luogo + ' · ' + EUR(B.prezzo) + '</span>' +
      '<button type="button" class="nm-lnk" data-nm-add="' + B.vid + '">Aggiungi</button></div></div></div>';
  }

  /* la scritta del Live riempie la sua colonna; si rifa' quando la colonna cambia (es. anteprima che si apre) */
  function fitBox(box){
    var t = box.firstElementChild; if (!t) return;
    var bw = box.clientWidth; if (!(bw > 0)) return;
    t.style.fontSize = '100px';
    var w = t.getBoundingClientRect().width;
    if (w > 0) t.style.fontSize = Math.min(52, Math.floor(100 * bw / w * 0.98)) + 'px';
  }
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function(es){ es.forEach(function(e){ fitBox(e.target); }); }) : null;
  function fit(root){
    (root||document).querySelectorAll('.nm-tk__t').forEach(function(box){
      fitBox(box);
      if (ro && !box.nmOss){ box.nmOss = 1; ro.observe(box); }
    });
    (root||document).querySelectorAll('.nm-tk video').forEach(function(v){ window.nmPlay(v); });
  }

  function nodo(html, cls){
    if (!html) return null;
    var el = document.createElement('div');
    el.className = 'nm-car' + (cls ? ' ' + cls : '');
    el.setAttribute('data-nm-car','1');
    el.innerHTML = html;
    return el;
  }
  /* segnaposto vuoto: dice al MutationObserver che il giro e' gia' stato fatto */
  function vuoto(w){ var z = document.createElement('i'); z.hidden = true; z.setAttribute('data-nm-car','1'); w.appendChild(z); }

  /* nell'anteprima, accanto al pagamento, la bolla per andare al carrello */
  function bottoni(){
    document.querySelectorAll('cart-drawer-component .cart__ctas, .cart-drawer__dialog .cart__ctas').forEach(function(c){
      var co = c.querySelector('.cart__checkout-button');
      if (co){ var t = co.querySelector('.button-text') || co; if (t.textContent.trim() !== 'Vai al pagamento') t.textContent = 'Vai al pagamento'; }
      if (c.querySelector('.nm-vai')) return;
      var a = document.createElement('a');
      a.className = 'nm-vai'; a.href = '/cart'; a.textContent = 'Visualizza carrello';
      if (co && co.nextSibling) c.insertBefore(a, co.nextSibling); else c.appendChild(a);
    });
  }

  function contenitori(){
    var tutti = [].slice.call(document.querySelectorAll('.cart-items__wrapper'));
    return tutti.filter(function(w){ return !tutti.some(function(v){ return v !== w && w.contains(v); }); });
  }

  var inCorso = false;
  function disegna(){
    if (inCorso) return; inCorso = true;
    pronto.then(function(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-nm-car]').forEach(function(n){ n.remove(); });
        var s = (cart.items && cart.items.length) ? conta(cart) : null;
        contenitori().forEach(function(w){
          if (!s) return vuoto(w);
          var pagina = !w.closest('cart-drawer-component, .cart-drawer__dialog');
          if (pagina){
            var sum = document.querySelector('.cart-page .cart-summary__inner');
            var a = nodo(sticker(s));
            if (a){ if (sum) sum.insertBefore(a, sum.firstChild); else w.appendChild(a); }
            else vuoto(w);
          } else {
            var n = nodo(sticker(s) + live(s));
            if (n) w.appendChild(n); else vuoto(w);
          }
        });
        fit(); bottoni();
      })
      .catch(function(){})
      .then(function(){ inCorso = false; });
  }

  /* aggiunge al carrello e ricarica; se si era nell'anteprima, la riapre */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-nm-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    var nelDrawer = !!b.closest('cart-drawer-component, .cart-drawer__dialog');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-nm-add')), quantity: 1 }] })
    }).then(function(r){
      if (!r.ok) throw r;
      try { if (nelDrawer) sessionStorage.setItem('nmApriCarrello','1'); } catch(_){}
      location.reload();
    }).catch(function(){ b.disabled = false; });
  });

  function riapri(){
    var si = false; try { si = sessionStorage.getItem('nmApriCarrello') === '1'; sessionStorage.removeItem('nmApriCarrello'); } catch(_){}
    if (!si) return;
    setTimeout(function(){
      var btn = document.querySelector('cart-drawer-component .header-actions__action, cart-drawer-component button');
      if (btn) btn.click();
    }, 400);
  }

  /* ridisegna quando il carrello cambia, comunque sia cambiato */
  var f = window.fetch;
  window.fetch = function(){
    var u = arguments[0];
    u = (typeof u === 'string') ? u : (u && u.url) || '';
    var p = f.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(disegna, 250); });
    return p;
  };
  ['cart:update','cart:refresh','CartUpdateEvent'].forEach(function(n){
    document.addEventListener(n, function(){ setTimeout(disegna, 150); });
  });
  new MutationObserver(function(){
    if (document.querySelector('.cart-drawer__dialog .cart__ctas:not(:has(.nm-vai))')) bottoni();
    if (!document.querySelector('[data-nm-car]') && contenitori().length) disegna();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.fonts && document.fonts.load) document.fonts.load('100px NMCarMalf', 'Live').then(function(){ fit(); }, function(){});
  window.addEventListener('resize', function(){ fit(); });
  document.addEventListener('click', function(e){ if (e.target.closest('cart-drawer-component .header-actions__action')) setTimeout(fit, 350); });

  function avvia(){ disegna(); riapri(); bottoni(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
